import { formatDistanceToNow } from 'date-fns';
import PropTypes from 'prop-types';
import ArrowRightIcon from '@heroicons/react/24/solid/ArrowRightIcon';
import EllipsisVerticalIcon from '@heroicons/react/24/solid/EllipsisVerticalIcon';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardHeader,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  SvgIcon
} from '@mui/material';

export const OverviewLatestCompletedRides = (props) => {
  const { rides = [], sx } = props;

  return (
    <Card sx={sx}>
      <CardHeader title="Latest Ride Completed" />
      <List>
        {rides.map((ride, index) => {
          const hasDivider = index < ride.length - 1;
          

          return (
            <ListItem
              divider={hasDivider}
              key={ride.id}
            >
             
              <ListItemText
                primary={`Rider Name:  ${ride.passenger_name}`}
                primaryTypographyProps={{ variant: 'subtitle1' }}
                secondary={`Passenger Name:  ${ride.passenger_name}`}
                secondaryTypographyProps={{ variant: 'body2' }}
              />
               Cost: {ride.price}
            </ListItem>
          );
        })}
      </List>
      <Divider />
    </Card>
  );
};

OverviewLatestCompletedRides.propTypes = {
  rides: PropTypes.array,
  sx: PropTypes.object
};
